<template>
  <div class="custom-button"
    v-bind:class="{ 'button-reset': isResetButton, 'button-apply': isApplyButton, 'isBlocked': isBlocked }"
    @click="clickHandler">
    {{ buttonText }}
  </div>
</template>

<script>
  export default {
    name: 'CustomButton',
    props: ['buttonText', 'buttonType', 'isBlocked'],
    computed: {
      isResetButton() {
        return this.buttonType === 'reset'
      },
      isApplyButton() {
        return this.buttonType === 'apply'
      }
    },
    methods: {
      clickHandler() {
        if (this.isBlocked) {
          return
        }
        this.$emit('clicked')
      }
    }
  }
</script>

<style>
.custom-button {
  display: flex;
  max-height: 20px;
  flex-grow: 1;
  justify-content: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  border-radius: 8px;
  padding: 10px 16px;
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  cursor: pointer;
  user-select: none;
  width: -webkit-fill-available;
  background: #D0D5DD;
  ;
}

.custom-button:hover {
  box-shadow: 0px 2px 4px 0px rgba(16, 24, 40, 0.1);
}

.button-reset {
  color: #344054;
  border: 1px solid #D0D5DD;
  background: #FFF;
}

.button-apply {
  color: #FFF;
  border: 1px solid var(--beel-primary);
  background-color: var(--beel-primary);
  transition: .4s;
}

.isBlocked {
  background: #D0D5DD;
  border: 1px solid #D0D5DD;
}
</style>



// WEBPACK FOOTER //
// src/components/client/Inputs/CustomButton.vue